meedy.controller('meedy.calendarDailyPlanController', ['$scope', '$state', '$stateParams', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.resourceModel', 'meedy.calendarModel', 'meedy.userModel', 'meedy.availabilityRuleModel',
    function ($scope, $state, $stateParams, $mdDialog, $translate, objectHelper, applicationModel, resourceModel, calendarModel, userModel, availabilityRuleModel) {

        function markResourceTab(resource) {
            // brute-force tab underline coloring, needs special trick to be able to apply !important
            var mdInkBar = $('md-ink-bar');
            if (resource && resource.id > 0) {
                mdInkBar[0].style.setProperty('background-color', resource.color, 'important');
            }
            else {
                mdInkBar[0].style.setProperty('background-color', '', 'important');
            }
        }

        function updateStateParameters() {
            // apparently state params updated with notify/reload false aren't preserved in $stateParams or $state.$current
            // (which kinda makes sense, if notify: false, but we want to prevent view reloading, too)
            // we still need these parameters to land in url (so that user can refresh or copy/paste), but we have to also store them internally
            // for daily view / plan view
            $scope.stateParameters = {
                dateSlug: 'date',
                date: $scope.calendarDate.getTime(),
                resourceSlug: 'resource',
                resourceId : $scope.currentResource.id
            };
            $state.transitionTo($state.current, $scope.stateParameters, { notify: false, reload: false });
        }

        // --- //

        function setData() {
            $scope.stateParameters = $stateParams;
            $scope.currentUserOriginSystem = userModel.currentUser.originSystem;
            $scope.groupTerms = [];

            $scope.columns = [];

            $scope.viewModes = [
                Enum.MEEDY.CALENDAR_VIEW_MODE.DAY,
                Enum.MEEDY.CALENDAR_VIEW_MODE.PLAN
            ];
            $scope.currentViewMode = $scope.viewModes[1];
            $scope.termPopupOpened = false;

            $scope.calendarDate = $stateParams.date ? new Date($stateParams.date) : new Date();

            $scope.resources = [
                objectHelper.o(ResourceMeedyVO, {
                    id: 0,
                    name: $scope.T('T.MEEDY.MODULE.CALENDAR.ALL_RESOURCES')
                })
            ];
            $scope.currentResource = null;

            $scope.moonPhase = null;
            $scope.moonPhaseIconClassName = null;
            $scope.namedays = null;

            $scope.requestParams = new CalendarDataRequestParamsMeedy();
            $scope.requestParams.startDate = $scope.calendarDate.getTime();
            $scope.requestParams.calendarType = Enum.MEEDY.CALENDAR_TYPE.DAILY;
            $scope.requestParams.termsOnly = true;

            $scope.events = [];

            // for check viprotect user has filled all data
            if(userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT && sessionStorage.getItem('filledData') != true) {
                userModel.getMyData();
            }
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            function buildGridData(terms) {
                $scope.flatGroupTerms = [];
                var flatGroupTerms = [];
                for(var i = 0; i < $scope.resources.length; i++) {
                    if($scope.resources[i].id > 0) {
                        flatGroupTerms.push({resource: $scope.resources[i], terms: []});
                    }
                }

                for(var i = 0; i < flatGroupTerms.length; i++) {
                    $scope.flatGroupTerms.push(flatGroupTerms[i]);

                    terms.forEach(function(term) {
                        if(term.resource && term.resource.id == flatGroupTerms[i].resource.id && flatGroupTerms[i].resource.id > 0) {
                            $scope.flatGroupTerms.push(term);
                        }
                    });
                }

                $scope.calendarReady = true;
            };

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$on(Event.MEEDY.RESOURCE.GET_RESOURCES_AVAILABLE_FOR_LOGGED_USER.SUCCESS, function (event, resources) {
                if (!$scope.termPopupOpened) {
                    $scope.resources = $scope.resources.concat(resources);

                    var resource = $scope.resources[0];

                    if ($stateParams.resourceId) {
                        var foundResource = _.find($scope.resources, function (resource) {
                            return (resource.id == $stateParams.resourceId);
                        });

                        if (foundResource) {
                            resource = foundResource;
                        }
                    }

                    $scope.currentResource = resource;
                    markResourceTab(resource);

                    updateStateParameters();
                }
            });

            $scope.$on(Event.MEEDY.CALENDAR.GET_MOON_PHASE.SUCCESS, function (event, moonPhase) {
                $scope.moonPhase = moonPhase;

                // because why having sane class names for icons, right? right?
                var className = '';
                switch (moonPhase) {
                    case Enum.MEEDY.MOON_PHASE.NEW:
                        className = 'flaticon-new42';
                        break;
                    case Enum.MEEDY.MOON_PHASE.WAXING_CRESCENT:
                        className = 'flaticon-moon113';
                        break;
                    case Enum.MEEDY.MOON_PHASE.FIRST_QUARTER:
                        className = 'flaticon-half21';
                        break;
                    case Enum.MEEDY.MOON_PHASE.WAXING_GIBBOUS:
                        className = 'flaticon-moon103';
                        break;
                    case Enum.MEEDY.MOON_PHASE.FULL:
                        className = 'flaticon-moon99';
                        break;
                    case Enum.MEEDY.MOON_PHASE.WANING_GIBBOUS:
                        className = 'flaticon-moon110';
                        break;
                    case Enum.MEEDY.MOON_PHASE.THIRD_QUARTER:
                        className = 'flaticon-moon94';
                        break;
                    case Enum.MEEDY.MOON_PHASE.WANING_CRESCENT:
                        className = 'flaticon-moon108';
                        break;
                }
                $scope.moonPhaseIconClassName = className;
            });

            $scope.$on(Event.MEEDY.CALENDAR.GET_NAMEDAYS.SUCCESS, function (event, namedays) {
                $scope.namedays = namedays;
            });

            $scope.$on(Event.MEEDY.CALENDAR.GET_CALENDAR_DATA.SUCCESS, function (event, calendarData) {
                var events = [];

                // pluck the events from within the map structure, reattach resources (that were stripped, but their ids are passed as map keys)
                _.forOwn(calendarData, function(value, key) {
                    _.forOwn(calendarData[key].terms, function(termsValue, termsKey) {
                        var idResource = termsKey;
                        _.each(termsValue, function(term) {
                            term.resource = {'id' : idResource};
                            events.push(term);
                        });
                    });
                });

                $scope.events = events;
                buildGridData(events);
            });


            $scope.$on(Event.MEEDY.CALENDAR.GET_DAILY_PLAN_TOKEN.SUCCESS, function(event, token) {
                calendarModel.downloadDailyPlan(token);
            });


            $scope.onCalendarButtonDateChanged = function(date) {
                $scope.goToDate(date);
            };

            $scope.onCurrentViewModeChange = function() {
                if ($scope.currentViewMode == Enum.MEEDY.CALENDAR_VIEW_MODE.DAY) {
                    $state.go(Constant.STATE.APP.MEEDY.CALENDAR.INDEX, $scope.stateParameters);
                }
            };

            $scope.$on(Event.MEEDY.USER.GET_MY_DATA.SUCCESS, function(event, userDetails) {
                if(!userDetails.medicalPostAccounting.nip) {
                    var configPopup = {
                        templateUrl: 'meedy/application/view/app/popup/popup-fill-data.html',
                        controller: 'meedy.popupFillDataController',
                        locals: {
                            $scope: $scope,
                            $mdDialog: $mdDialog
                        }
                    };
                    $mdDialog.show(configPopup).then(function() {
                        $state.go(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);
                    });
                } else {
                    var officeId = userDetails.user.resources[0].id;
                    resourceModel.getPricelist(officeId);
                }
            });

            $scope.$on(Event.MEEDY.RESOURCE.GET_PRICE_LIST.SUCCESS, function(event, priceList) {
                if(!priceList.pricelistItems || priceList.pricelistItems.length === 0) {
                    var configPopup = {
                        templateUrl: 'meedy/application/view/app/popup/popup-fill-price-list.html',
                        controller: 'meedy.popupFillDataController',
                        locals: {
                            $scope: $scope,
                            $mdDialog: $mdDialog
                        }
                    };
                    $mdDialog.show(configPopup).then(function() {
                        $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST);
                    });
                } else {
                    availabilityRuleModel.getAvailabilityRules();
                }
            });

            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULES.SUCCESS, function(event, list) {
                if(!list[0].currentAvailabilityRule && list[0].futureAvailabilityRules.length === 0) {
                    var configPopup = {
                        templateUrl: 'meedy/application/view/app/popup/popup-fill-availability.html',
                        controller: 'meedy.popupFillDataController',
                        locals: {
                            $scope: $scope,
                            $mdDialog: $mdDialog
                        }
                    };
                    $mdDialog.show(configPopup).then(function() {
                        $state.go(Constant.STATE.APP.MEEDY.SETTINGS.AVAILABILITY.LIST);
                    });
                } else {
                    sessionStorage.setItem('filledData', 'true');
                }
            });
        }

        function setColumns() {
            $scope.columns = [$translate.instant('T.MEEDY.MODULE.CALENDAR.DAILY_PLAN.WELCOME_HOURS'),
                $translate.instant('T.MEEDY.MODULE.CALENDAR.DAILY_PLAN.FULL_NAME'),
                $translate.instant('T.MEEDY.MODULE.CALENDAR.DAILY_PLAN.CONTACT_PHONE'),
                $translate.instant('T.MEEDY.MODULE.CALENDAR.DAILY_PLAN.INSURER'),
                $translate.instant('T.MEEDY.MODULE.CALENDAR.DAILY_PLAN.PAYER'),
                $translate.instant('T.MEEDY.MODULE.CALENDAR.DAILY_PLAN.OTHER')
            ];
        }

        function setActions() {
            $scope.showTerm = function(term) {
                if(!($scope.isReceptionist && term.type === Enum.MEEDY.TERM_TYPE.PRIVATE_TERM)) {
                    var termId = term.id;
                    $scope.termPopupOpened = true;

                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-view-popup.html',
                        controller: 'meedy.popupCalendarTermViewController',
                        resolve: {
                            termId: function () {
                                return termId;
                            }
                        }
                    }).then(function (dialogResult) {
                        $scope.termPopupOpened = false;

                        if (dialogResult) {
                            var term = dialogResult.data;
                            var eventName = dialogResult.eventName;

                            if ((eventName == Constant.MEEDY.DIALOG_EVENT.TERM.AFTER_DELETE) || (eventName == Constant.MEEDY.DIALOG_EVENT.TERM.AFTER_CYCLIC_DELETE)) {
                                var toast = $mdToast.simple()
                                    .textContent($scope.T('T.MEEDY.MODULE.CALENDAR.TERM.TERM_DELETED'))
                                    //.action($scope.T('T.MEEDY.MODULE.CALENDAR.TERM.RESTORE_TERM'))
                                    .position('top right');

                                $mdToast.show(toast).then(function (response) {
                                    // toast has only one action, and that action has 'ok' response, otherwise the resolve action is true
                                    if (response == 'ok') {
                                        //console.log('przywroc termin');
                                        //console.log(term);
                                    }
                                });

                                if (term) {
                                    var termBeginMoment = moment(term.begin);
                                    var calendarDateMoment = moment($scope.calendarDate);

                                    if (calendarDateMoment.isSame(termBeginMoment, 'year') && calendarDateMoment.isSame(termBeginMoment, 'month') && calendarDateMoment.isSame(termBeginMoment, 'day')) {
                                        calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
                                    }
                                }
                            }
                            else if (eventName == Constant.MEEDY.DIALOG_EVENT.TERM.EDIT) {
                                $scope.editTerm(term, true);
                            }
                            else if (eventName == Constant.MEEDY.DIALOG_EVENT.TERM.CANCEL) {
                                $scope.cancelTerm(term, true);
                            }
                        }

                    }, function (error) {
                        $scope.termPopupOpened = false;
                    })
                }
            };

            $scope.showEventsForResource = function(resource) {
                // don't enter on initial buggy md-on-select trigger on tabs, calendarReady is never true yet at this point, so we can use it
                if ($scope.calendarReady) {
                    $scope.currentResource = resource;

                    markResourceTab(resource);

                    updateStateParameters();
                }
            };

            $scope.createTerm = function() {
                $scope.termPopupOpened = true;

                var currentResource = $scope.currentResource && $scope.currentResource.id != 0 ? $scope.currentResource : null;

                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-create-popup.html',
                    controller: 'meedy.popupCalendarTermCreateController',
                    resolve: {
                        date: function() {
                            return null;
                        },
                        resource: function() {
                            return currentResource;
                        },
                        termWrapper: function() {
                            return {};
                        }
                    }
                }).then(function(newTerm) {
                    $scope.termPopupOpened = false;

                    var newTermBeginMoment = moment(newTerm.begin);
                    var calendarDateMoment = moment($scope.calendarDate);

                    if (calendarDateMoment.isSame(newTermBeginMoment, 'year') && calendarDateMoment.isSame(newTermBeginMoment, 'month') && calendarDateMoment.isSame(newTermBeginMoment, 'day')) {
                        calendarModel.getCalendarData($scope.requestParams);
                    }
                }, function(error){
                    $scope.termPopupOpened = false;
                });
            };

            $scope.goToDate = function(date, respectTime) {
                var targetDate = moment(date);
                if (!respectTime) {
                    targetDate.set({'hour': 0, 'minute': 0, 'second': 0});
                }
                $scope.calendarDate = targetDate.clone().toDate();

                calendarModel.getMoonPhase($scope.calendarDate);
                calendarModel.getNameDays($scope.calendarDate);

                updateStateParameters();

                $scope.requestParams.startDate = $scope.calendarDate.getTime();
                calendarModel.getCalendarData($scope.requestParams);
            };

            $scope.goToToday = function() {
                $scope.goToDate(new Date());
            };

            $scope.goToTomorrow = function() {
                $scope.goToDate(moment().add(1, 'days').toDate());
            };

            $scope.isTodayPressed = function(calendarDate) {
                var calendarDateMoment = moment(calendarDate);
                var today = moment();
                return (calendarDateMoment.isSame(today, 'year') && calendarDateMoment.isSame(today, 'month') && calendarDateMoment.isSame(today, 'day'));
            };

            $scope.isTomorrowPressed = function(calendarDate) {
                var calendarDateMoment = moment(calendarDate);
                var tomorrow = moment().add(1, 'days');
                return (calendarDateMoment.isSame(tomorrow, 'year') && calendarDateMoment.isSame(tomorrow, 'month') && calendarDateMoment.isSame(tomorrow, 'day'));
            };

            $scope.downloadDailyPlan = function() {
                calendarModel.getDailyPlanToken({
                    startDate : $scope.calendarDate.getTime(),
                    generatedFileType: "DAILY_PLAN_PDF",
                    resourceId : $scope.currentResource.id != 0 ? $scope.currentResource.id : null
                });
            }
        }

        function configureInterface() {
            applicationModel.selectSideBarItemWithState(Constant.STATE.APP.MEEDY.CALENDAR.INDEX);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.MODULE.CALENDAR.CALENDAR_PLAN');
        }

        function initialize() {
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;

            resourceModel.getResourcesAvailableForLoggedUser();
            calendarModel.getMoonPhase($scope.calendarDate);
            calendarModel.getNameDays($scope.calendarDate);
            calendarModel.getCalendarData($scope.requestParams);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        setColumns();
        configureInterface();
        initialize();
    }
]);
